import React, { useEffect } from "react";
import { BrowserRouter, useLocation, useNavigate } from "react-router-dom";
import { AdminRoute } from "./Routing/AdminRoute";
import { ToastContainer } from "react-toastify";

const AppContent = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Allow these paths for protected file access & login redirects
    const isAllowed =
      location.pathname.startsWith("/secure-viewer") ||
      location.pathname.startsWith("/user/login");

    if (!location.pathname.startsWith("/admin") && !isAllowed) {
      navigate("/admin/login", { replace: true });
    }
  }, [location, navigate]);

  return <AdminRoute />;
};

export const App = () => {
  return (
    <BrowserRouter>
      <ToastContainer />
      <AppContent />
    </BrowserRouter>
  );
};
